import { render, staticRenderFns } from "./ServerListPage.vue?vue&type=template&id=288a4f08&scoped=true&"
import script from "./ServerListPage.vue?vue&type=script&lang=js&"
export * from "./ServerListPage.vue?vue&type=script&lang=js&"
import style0 from "./ServerListPage.vue?vue&type=style&index=0&id=288a4f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288a4f08",
  null
  
)

export default component.exports